import URLConfig from '@Config/urls/url.config';
import { Route } from 'react-router-dom';
import * as InterfaceModule from '@Modules/interfaceManagement/interface/pages';
import React from 'react';

const URL = URLConfig.INTERFACE_MANAGEMENT.INTERFACE;

const InterfaceRoutes = [
    <Route
      path={URL.RISK_MANAGEMENT}
      element={<InterfaceModule.RiskManagement />}
    />,
    <Route
      path={URL.ROUTING}
      element={<InterfaceModule.Routing />}
    />,
    <Route
      path={URL.BIN}
      element={<InterfaceModule.BIN />}
    />,
    <Route
      path={URL.SUPERVISION}
      element={<InterfaceModule.Supervision />}
    />,
    // Authorization MENU ROUTES
    <Route>
      {AuthorizationsMenuRoutes().map((oneRoute, index) => (
        <React.Fragment key={index}>{oneRoute}</React.Fragment>
      ))}
    </Route>,
    // Interface MENU ROUTES
    <Route>
      {InterfaceMenuRoutes().map((oneRoute, index) => (
        <React.Fragment key={index}>{oneRoute}</React.Fragment>
      ))}
    </Route>,
];


function AuthorizationsMenuRoutes() {
  return [
    <Route
      path={URL.AUTHORIZATIONS.CONSULTING_AUTHORIZATIONS}
      element={<InterfaceModule.ConsultingAuthorizations />}
    />,
    <Route
      path={URL.AUTHORIZATIONS.SAF_CONSULTATION}
      element={<InterfaceModule.SAFConsultation />}
    />,
  ];
}

function InterfaceMenuRoutes() {
  return [
    <Route
      path={URL.INTERFACE.UPDATE}
      element={<InterfaceModule.Update />}
    />,
    <Route
      path={URL.INTERFACE.HSM}
      element={<InterfaceModule.HSM />}
    />,
    <Route
      path={URL.INTERFACE.SUPERVISOR}
      element={<InterfaceModule.Supervisor />}
    />,
  ];
}


export default InterfaceRoutes;
